import { flatten } from "lodash";
import { all, put } from "redux-saga/effects";
import { showError } from "../components/toaster/store/slice";
import { ApiErrors } from "./api";

function* handleApiError(errors: ApiErrors) {
  const messages = flatten(Object.values(errors));

  yield all(messages.map((message) => put(showError(message))));
}

export default handleApiError;
